var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("g-breadcrumb", {
        attrs: { paginas: _vm.paginaStatus.caminhoMigalha }
      }),
      _c("div", { staticClass: "q-card gvn-cabecalho " }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Requerente: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.movimentacaoProcesso.aberturaProcesso
                    .requerente.nomRequerente
                ) +
                "\n      "
            )
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Logradouro: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.movimentacaoProcesso.aberturaProcesso
                    .requerente.logradouro.nomLogradouro
                ) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Número: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.movimentacaoProcesso.aberturaProcesso
                    .requerente.numNumero
                ) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Nº do Processo | Ano: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.movimentacaoProcesso.aberturaProcesso
                    .numProcesso
                ) +
                " | " +
                _vm._s(
                  this.paginaStatus.movimentacaoProcesso.aberturaProcesso
                    .anoProcesso
                ) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Tipo de Processo: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.movimentacaoProcesso.aberturaProcesso
                    .tipoProcesso.desTipoProcesso
                ) +
                "\n      "
            )
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Bairro: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.movimentacaoProcesso.aberturaProcesso
                    .requerente.bairro.nomBairro
                ) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Cidade: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.movimentacaoProcesso.aberturaProcesso
                    .requerente.municipio.nomMunicipio
                ) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Nº Protocolo: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.movimentacaoProcesso.aberturaProcesso
                    .numProtocolo
                ) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Assunto: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.movimentacaoProcesso.aberturaProcesso
                    .subassunto.assunto.desAssunto
                ) +
                "\n      "
            )
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("E-mail: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.movimentacaoProcesso.aberturaProcesso
                    .requerente.txtEmail ||
                    this.paginaStatus.usuarioPortal.txtEmail
                ) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("UF: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.movimentacaoProcesso.aberturaProcesso
                    .requerente.uf.nomUf
                ) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Rota: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.movimentacaoProcesso.aberturaProcesso
                    .roteiro.numRota
                ) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Subassunto: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.movimentacaoProcesso.aberturaProcesso
                    .subassunto.desSubassunto
                ) +
                "\n      "
            )
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Telefone móvel: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.movimentacaoProcesso.aberturaProcesso
                    .requerente.numTelefoneMovel ||
                    this.paginaStatus.usuarioPortal.numTelefoneMovel
                ) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Telefone Comercial: ")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  this.paginaStatus.movimentacaoProcesso.aberturaProcesso
                    .requerente.numTelefoneComercial ||
                    this.paginaStatus.usuarioPortal.numTelefoneComercial
                ) +
                "\n      "
            )
          ]),
          _c("div", { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" }, [
            _c("strong", [_vm._v("Data | Hora: ")]),
            _vm._v("\n        " + _vm._s(this.datProcesso) + "\n      ")
          ])
        ]),
        _c("br"),
        _c("br"),
        _vm.arrayDocumentosNecessarios.length > 0
          ? _c(
              "div",
              {
                staticClass: "row",
                staticStyle: { "margin-right": "8px", "margin-left": "8px" }
              },
              [
                _c(
                  "table",
                  {
                    staticClass: "col-md-12",
                    attrs: { cellspacing: "0", cellpadding: "0" }
                  },
                  [
                    _vm._m(0),
                    _c(
                      "tbody",
                      _vm._l(_vm.arrayDocumentosNecessarios, function(doc) {
                        return _c("tr", { key: doc.a }, [
                          _c("td", { staticClass: "text-left" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(doc.documento.nomDocumento) +
                                "\n            "
                            )
                          ])
                        ])
                      })
                    )
                  ]
                )
              ]
            )
          : _vm._e()
      ]),
      _c(
        "form",
        {
          staticStyle: { "margin-top": "25px" },
          attrs: { enctype: "multipart/form-data" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.salvar($event)
            }
          }
        },
        [
          _c(
            "g-gridview",
            {
              ref: "refDocumentos",
              attrs: {
                id: "refDocumentos",
                name: "refDocumentos",
                exibirEtiqueta: false,
                colunas: _vm.colunasGrid,
                inserirElemento: _vm.getElemento,
                getElemento: _vm.getElemento,
                editarElemento: _vm.editarElemento,
                executarValidacao: _vm.validarDocumento,
                limparCampos: _vm.limparDocumento,
                exibirBotaoExclusao: _vm.exclusao,
                desabilitar: _vm.paginaStatus.desabilitarEdicao,
                confExcluir: _vm.confExcluirDocumento,
                inicializarVazio: true,
                exibirBotaoVisualizacao: false,
                exibirBotaoEdicao: false,
                operacoes: _vm.operacoes
              }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 gvn-title-primary mrg-t-0" }, [
                  _vm._v("Dados da Anexação")
                ])
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-sm-6 col-xs-6" },
                  [
                    _c("g-autocomplete", {
                      ref: "refResponsavel",
                      attrs: {
                        id: "refResponsavel",
                        name: "refResponsavel",
                        validacao: "required",
                        etiqueta: "Responsável",
                        valor: "usuario.codUsuario",
                        descricaoPrimaria: "usuario.nomUsuario",
                        api: _vm.apiResponsavelSetor,
                        foco: false,
                        filtroAdicional: _vm.filtroAdicionalResponsavel,
                        desabilitar: true
                      },
                      model: {
                        value: _vm.codUsuario,
                        callback: function($$v) {
                          _vm.codUsuario = $$v
                        },
                        expression: "codUsuario"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-sm-4 col-xs-4",
                    staticStyle: { "padding-right": "10px" }
                  },
                  [
                    _c("g-dateInput", {
                      ref: "refDataAnexacao",
                      attrs: {
                        id: "refDataAnexacao",
                        name: "refDataAnexacao",
                        etiqueta: "Data de Anexação",
                        validacao: "required",
                        desabilitar: false,
                        somenteLeitura: _vm.paginaStatus.desabilitarEdicao,
                        dataMax: new Date()
                      },
                      model: {
                        value: _vm.datAnexacao,
                        callback: function($$v) {
                          _vm.datAnexacao = $$v
                        },
                        expression: "datAnexacao"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-sm-6 col-xs-6",
                    staticStyle: { "padding-top": "9px" }
                  },
                  [
                    _c("g-autocomplete", {
                      ref: "refDocumento",
                      attrs: {
                        id: "refDocumento",
                        name: "refDocumento",
                        etiqueta: "Documento",
                        valor: "codDocumento",
                        descricaoPrimaria: "nomDocumento",
                        validacao: "required",
                        api: _vm.apiDocumento,
                        foco: false,
                        desabilitar: _vm.paginaStatus.desabilitarEdicao,
                        permitirTextoLivre: ""
                      },
                      model: {
                        value: _vm.codDocumento,
                        callback: function($$v) {
                          _vm.codDocumento = $$v
                        },
                        expression: "codDocumento"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-sm-6 col-xs-6",
                    staticStyle: { "padding-top": "9px" }
                  },
                  [
                    _c("q-uploader", {
                      ref: "refUploader",
                      attrs: {
                        color: "secondary",
                        name: "arquivo",
                        type: "file",
                        "auto-expand": "",
                        "hide-upload-button": "",
                        "hide-upload-progress": "",
                        validacao: "required",
                        "stack-label":
                          "Selecionar arquivo (Tamanho máximo: 25Mb)",
                        url: _vm.urlArquivo,
                        filter: _vm.filtroDeArquivos
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-sm-12 col-xs-12",
                    staticStyle: { "padding-top": "9px" }
                  },
                  [
                    _c("g-input", {
                      ref: "refObservacao",
                      attrs: {
                        id: "refObservacao",
                        name: "refObservacao",
                        tipo: "textarea",
                        etiqueta: "Observação",
                        tamanho: 1000,
                        foco: false,
                        desabilitar: _vm.paginaStatus.desabilitarEdicao
                      },
                      model: {
                        value: _vm.txtObservacao,
                        callback: function($$v) {
                          _vm.txtObservacao = $$v
                        },
                        expression: "txtObservacao"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-5 col-md-5 col-sm-11 col-xs-11" },
                  [
                    _c("g-select", {
                      ref: "disponibilidade",
                      attrs: {
                        id: "refDisponibilidade",
                        name: "disponibilidade",
                        etiqueta: "Arquivo ficará disponível",
                        foco: false,
                        itens: _vm.arrayDisponibilidadeArray,
                        "item-valor": "codigo",
                        "item-etiqueta": "descricao",
                        desabilitar: _vm.paginaStatus.desabilitarEdicao
                      },
                      model: {
                        value: _vm.disponibilidade,
                        callback: function($$v) {
                          _vm.disponibilidade = $$v
                        },
                        expression: "disponibilidade"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-lg-1 col-md-1 col-sm-1 col-xs-1" },
                  [
                    _c(
                      "q-btn",
                      {
                        staticStyle: { "margin-top": "15px" },
                        attrs: {
                          round: "",
                          outline: "",
                          icon: "fas fa-info",
                          size: "sm",
                          color: "blue-10"
                        }
                      },
                      [
                        _c(
                          "q-tooltip",
                          {
                            staticStyle: { "font-size": "13px" },
                            attrs: {
                              anchor: "top middle",
                              self: "bottom middle",
                              offset: [10, 10]
                            }
                          },
                          [
                            _c("strong", [_vm._v("Internamente:")]),
                            _vm._v(
                              " Ficará disponível internamente no processo. "
                            ),
                            _c("br"),
                            _c("br"),
                            _c("strong", [_vm._v("Externamente:")]),
                            _vm._v(
                              " Ficará disponível para o requisitante no "
                            ),
                            _c("strong", [_vm._v("Portal Web.")]),
                            _c("br"),
                            _c("br"),
                            _c("strong", [
                              _vm._v(
                                "Externamente (Apenas no encerramento do processo): "
                              )
                            ]),
                            _vm._v(
                              "\n              Ficará disponível para o requisitante no "
                            ),
                            _c("strong", [_vm._v("Portal Web ")]),
                            _vm._v(
                              "\n              se o status do processo for "
                            ),
                            _c("strong", [_vm._v(" Encerrado ")])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.disponibilidade === "EXT"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-6 col-md-6 col-sm-12 col-xs-12 mrg-t-10"
                      },
                      [
                        _c("q-toggle", {
                          attrs: {
                            id: "toogleSetorAtivo",
                            name: "toogleSetorAtivo",
                            label: "Gerar uma nova pendência",
                            color: "teal-8",
                            disable: _vm.paginaStatus.desabilitarEdicao,
                            "true-value": "S",
                            "false-value": "N",
                            "checked-icon": "check",
                            "unchecked-icon": "clear"
                          },
                          model: {
                            value: _vm.indGerarNovaPendencia,
                            callback: function($$v) {
                              _vm.indGerarNovaPendencia = $$v
                            },
                            expression: "indGerarNovaPendencia"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]
          )
        ],
        1
      ),
      _vm.exibirArquivosSolicitacao
        ? _c(
            "q-card",
            [
              _c("q-card-main", [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 gvn-title-primary mrg-t-0" },
                    [_vm._v("Arquivos anexados na solicitação")]
                  )
                ]),
                _c("div", { staticClass: "row mrg-b-20" }, [
                  _c(
                    "div",
                    { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" },
                    [
                      _c("g-datatable", {
                        ref: "refSolicitacaoMovimentacaoDocumentos",
                        attrs: {
                          id: "refSolicitacaoMovimentacaoDocumentos",
                          name: "refSolicitacaoMovimentacaoDocumentos",
                          colunas: _vm.colunasSolicitacaoDocumentos,
                          operacoes: _vm.operacoesSolicitacaoDocumentos,
                          exibirColunaOperacoes: true,
                          carregamentoInicial: false
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "col-12 text-right pad-20t-h10-80b" },
        [
          _c(
            "q-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.paginaStatus.desabilitarEdicao,
                  expression: "!paginaStatus.desabilitarEdicao"
                }
              ],
              staticClass: "fixed",
              staticStyle: { right: "18px", bottom: "18px" },
              attrs: {
                round: "",
                id: "btnSalvar",
                name: "btnSalvar",
                color: "positive",
                icon: "check",
                size: "lg"
              },
              on: { click: _vm.salvar }
            },
            [_c("q-tooltip", [_vm._v("Salvar")])],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-left", attrs: { width: "50%" } }, [
          _vm._v("\n              Documentação Obrigatória\n            ")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }